import { getGenderOptions } from "Utils";
import {
  getLanguageOptions,
  getCountryOptions,
  getNationalityOptions,
} from "@toddle-edu/common-utils";

const STUDENT_FIELD_UIDS = {
  GENDER: "gender",
  DOB: "dob",
  ENROLLMENT_DATE: "enrollment_date",
  WITHDRAWAL_DATE: "withdrawal_date",
  ADDRESS_LINE_1: "address_line_1",
  ADDRESS_LINE_2: "address_line_2",
  CITY: "city",
  STATE: "state",
  ZIP_CODE: "zipcode",
  COUNTRY: "country",
  FIRST_NATIONALITY: "primary_nationality",
  SECOND_NATIONALITY: "secondary_nationality",
  FIRST_LANGUAGE: "first_language",
  SECOND_LANGUAGE: "second_language",
  FIRST_ADDITIONAL_FIELD: "first_additional_field",
  SECOND_ADDITIONAL_FIELD: "second_additional_field",
  THIRD_ADDITIONAL_FIELD: "third_additional_field",
  FOURTH_ADDITIONAL_FIELD: "fourth_additional_field",
  FIFTH_ADDITIONAL_FIELD: "fifth_additional_field",
  SIXTH_ADDITIONAL_FIELD: "sixth_additional_field",
  SEVENTH_ADDITIONAL_FIELD: "seventh_additional_field",
  EIGHTH_ADDITIONAL_FIELD: "eighth_additional_field",
};

export const STUDENT_BASIC_FIELDS = t => [
  {
    label: t("common:gender"),
    fieldUid: STUDENT_FIELD_UIDS.GENDER,
    fieldType: "SelectDropdown",
    options: getGenderOptions(t),
  },
  {
    label: t("common:dob"),
    fieldUid: STUDENT_FIELD_UIDS.DOB,
    fieldType: "datePicker",
  },
  {
    label: t("transcript:enrollment_date"),
    fieldUid: STUDENT_FIELD_UIDS.ENROLLMENT_DATE,
    fieldType: "datePicker",
  },
  {
    label: t("common:withdrawal_date"),
    fieldUid: STUDENT_FIELD_UIDS.WITHDRAWAL_DATE,
    fieldType: "datePicker",
  },
  {
    label: t("common:address_line_number", { number: 1 }),
    fieldUid: STUDENT_FIELD_UIDS.ADDRESS_LINE_1,
    fieldType: "TextInput",
    placeholder: t("common:enter_with_label", {
      label: t("common:address_line_number", { number: 1 }),
    }),
    span: 2,
  },
  {
    label: t("common:address_line_number", { number: 2 }),
    fieldUid: STUDENT_FIELD_UIDS.ADDRESS_LINE_2,
    fieldType: "TextInput",
    placeholder: t("common:enter_with_label", {
      label: t("common:address_line_number", { number: 2 }),
    }),
    span: 2,
  },
  {
    label: t("common:city"),
    fieldUid: STUDENT_FIELD_UIDS.CITY,
    fieldType: "TextInput",
    placeholder: t("common:enter_with_label", {
      label: t("common:city"),
    }),
  },
  {
    label: t("common:state"),
    fieldUid: STUDENT_FIELD_UIDS.STATE,
    fieldType: "TextInput",
    placeholder: t("common:enter_with_label", {
      label: t("common:state"),
    }),
  },
  {
    label: t("common:zipCode"),
    fieldUid: STUDENT_FIELD_UIDS.ZIP_CODE,
    fieldType: "TextInput",
    placeholder: t("common:enter_with_label", {
      label: t("common:zipCode"),
    }),
  },
  {
    label: t("common:country"),
    fieldUid: STUDENT_FIELD_UIDS.COUNTRY,
    fieldType: "SelectDropdown",
    options: getCountryOptions(),
  },
  {
    label: t("common:first_nationality"),
    fieldUid: STUDENT_FIELD_UIDS.FIRST_NATIONALITY,
    fieldType: "SelectDropdown",
    options: getNationalityOptions(),
  },
  {
    label: t("common:second_nationality"),
    fieldUid: STUDENT_FIELD_UIDS.SECOND_NATIONALITY,
    fieldType: "SelectDropdown",
    options: getNationalityOptions(),
  },
  {
    label: t("common:first_language"),
    fieldUid: STUDENT_FIELD_UIDS.FIRST_LANGUAGE,
    fieldType: "SelectDropdown",
    options: getLanguageOptions(),
  },
  {
    label: t("common:second_language"),
    fieldUid: STUDENT_FIELD_UIDS.SECOND_LANGUAGE,
    fieldType: "SelectDropdown",
    options: getLanguageOptions(),
  },
];

export const STUDENT_ADDITIONAL_FIELDS = [
  STUDENT_FIELD_UIDS.FIRST_ADDITIONAL_FIELD,
  STUDENT_FIELD_UIDS.SECOND_ADDITIONAL_FIELD,
  STUDENT_FIELD_UIDS.THIRD_ADDITIONAL_FIELD,
  STUDENT_FIELD_UIDS.FOURTH_ADDITIONAL_FIELD,
  STUDENT_FIELD_UIDS.FIFTH_ADDITIONAL_FIELD,
  STUDENT_FIELD_UIDS.SIXTH_ADDITIONAL_FIELD,
  STUDENT_FIELD_UIDS.SEVENTH_ADDITIONAL_FIELD,
  STUDENT_FIELD_UIDS.EIGHTH_ADDITIONAL_FIELD,
];

export const KEY_SEPARATOR = "=>";

export const TRANSCRIPT_DATA_SOURCE = {
  TODDLE: "TODDLE",
  CUSTOM: "CUSTOM",
};

export const CELL_TYPES = {
  TEXT: "text",
  DROPDOWN: "dropdown",
  TAG: "tag",
  LABEL: "label",
  ICON: "icon",
  TOGGLE: "toggle",
  STUDENT: "student",
};

export const EMPTY_ARRAY = [];

export const PROFILE_ADDITIONAL_FIELDS = {
  [STUDENT_FIELD_UIDS.FIRST_ADDITIONAL_FIELD]: {
    displayPerm: "FeatureFlag:EnableFirstFieldInPersonalInfo",
    customLabelPerm: "StudentProfileFirstAdditionalFieldLabel",
  },
  [STUDENT_FIELD_UIDS.SECOND_ADDITIONAL_FIELD]: {
    displayPerm: "FeatureFlag:EnableSecondFieldInPersonalInfo",
    customLabelPerm: "StudentProfileSecondAdditionalFieldLabel",
  },
  [STUDENT_FIELD_UIDS.THIRD_ADDITIONAL_FIELD]: {
    displayPerm: "FeatureFlag:EnableThirdFieldInPersonalInfo",
    customLabelPerm: "StudentProfileThirdAdditionalFieldLabel",
  },
  [STUDENT_FIELD_UIDS.FOURTH_ADDITIONAL_FIELD]: {
    displayPerm: "FeatureFlag:EnableFourthFieldInPersonalInfo",
    customLabelPerm: "StudentProfileFourthAdditionalFieldLabel",
  },
  [STUDENT_FIELD_UIDS.FIFTH_ADDITIONAL_FIELD]: {
    displayPerm: "FeatureFlag:EnableFifthFieldInPersonalInfo",
    customLabelPerm: "StudentProfileFifthAdditionalFieldLabel",
  },
  [STUDENT_FIELD_UIDS.SIXTH_ADDITIONAL_FIELD]: {
    displayPerm: "FeatureFlag:EnableSixthFieldInPersonalInfo",
    customLabelPerm: "StudentProfileSixthAdditionalFieldLabel",
  },
  [STUDENT_FIELD_UIDS.SEVENTH_ADDITIONAL_FIELD]: {
    displayPerm: "FeatureFlag:EnableSeventhFieldInPersonalInfo",
    customLabelPerm: "StudentProfileSeventhAdditionalFieldLabel",
  },
  [STUDENT_FIELD_UIDS.EIGHTH_ADDITIONAL_FIELD]: {
    displayPerm: "FeatureFlag:EnableEighthFieldInPersonalInfo",
    customLabelPerm: "StudentProfileEighthAdditionalFieldLabel",
  },
};

export const ADDITIONAL_FIELD_UID_TO_CONFIG_UID_MAP = {
  [STUDENT_FIELD_UIDS.FIRST_ADDITIONAL_FIELD]: "firstAdditionalField",
  [STUDENT_FIELD_UIDS.SECOND_ADDITIONAL_FIELD]: "secondAdditionalField",
  [STUDENT_FIELD_UIDS.THIRD_ADDITIONAL_FIELD]: "thirdAdditionalField",
  [STUDENT_FIELD_UIDS.FOURTH_ADDITIONAL_FIELD]: "fourthAdditionalField",
  [STUDENT_FIELD_UIDS.FIFTH_ADDITIONAL_FIELD]: "fifthAdditionalField",
  [STUDENT_FIELD_UIDS.SIXTH_ADDITIONAL_FIELD]: "sixthAdditionalField",
  [STUDENT_FIELD_UIDS.SEVENTH_ADDITIONAL_FIELD]: "seventhAdditionalField",
  [STUDENT_FIELD_UIDS.EIGHTH_ADDITIONAL_FIELD]: "eighthAdditionalField",
};

export const TRANSCRIPTS_V3_EDIT_GRADES_BANNER_CLOSED =
  "TranscriptsV3EditGradesBannerClosed";
